// Define the color mapping for each Y value (series)
export const colorMapping: Record<string, string> = {
    "Amsterdam": "#5AAF5C",
    "Arnhem - Duiven": "#457DA0",
    "Delft": "#FFAA39",
    "Groningen": "#DD4E4E",
    "Utrecht": "#C369E0",
    "Barendrecht": "#F268D8",
    "Haarlem": "#6ADFEF",
    "Eindhoven": "#6B7BED",
    "Amersfoort": "#E56CB4",
    "Breda": "#ACD146",
    "Hengelo": "#CE4670",
    "Heerlen": "#ECEF65",
    "Zwolle": "#60E294",
    "Overig": "#E89754"
};